import { render } from "./Menus.vue?vue&type=template&id=1f7a2365"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Menus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f7a2365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f7a2365', __exports__)) {
    console.log('reload')
    api.reload('1f7a2365', __exports__)
  }
  
  module.hot.accept("./Menus.vue?vue&type=template&id=1f7a2365", () => {
    console.log('re-render')
    api.rerender('1f7a2365', render)
  })

}


export default __exports__